const translations = {
  "en": {
    "HK AI": "HK AI",
    "HK AI Compute": "HK AI Compute",
    "HK AI Models": "HK AI Models",
    "HK AI Photonics": "HK AI Photonics",
    "HK Robotics": "HK Robotics",
    "US AI Photonics": "US AI Photonics",
    "US Data Center": "US Data Center",
    "US Nuclear": "US Nuclear",
    "US Oil & Energy": "US Oil & Energy",
    "US Robotics": "US Robotics"
  },
  "zh-tw": {
    "HK AI": "港股 AI",
    "HK AI Compute": "港股 AI 算力",
    "HK AI Models": "港股 AI 模型",
    "HK AI Photonics": "港股 AI 光通訊",
    "HK Robotics": "港股機器人",
    "US AI Photonics": "美股 AI 光通訊",
    "US Data Center": "美股資料中心",
    "US Nuclear": "美股核能",
    "US Oil & Energy": "美股石油與能源",
    "US Robotics": "美股機器人"
  }
};

export default translations;
